module.exports = __webpack_public_path__ + "media/logo.72612c6a.svg";